import { Header } from "./Header";
import { Footer } from "./Footer";

export const Layout = ({ children }) => (
  <div className="flex min-h-screen flex-col bg-white">
    <Header />
    <main id="main" className="flex-1 pt-20">
      {children}
    </main>
    <Footer />
  </div>
);
